import React from "react";
import PropTypes from "prop-types";

import "./RadioSelectItem.css";

export default function RadioSelectItem({
	value: { id, builtId, isSelected, selector, isDisabled },
}){
	return (
		<div className="radio-select-container">
			<input
				id={builtId}
				type="radio"
				name="itemValue"
				value={id}
				checked={isSelected}
				disabled={isDisabled}
				onChange = {() => { selector([id]); }}
			/>
		</div>
	);
}

RadioSelectItem.displayName = "RadioSelectItem";
RadioSelectItem.propTypes = {
	value:PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		isSelected: PropTypes.bool,
		selector: PropTypes.func.isRequired,
	}).isRequired,
};
